import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/new-dfod.svg'
import _imports_1 from '@/app/ui/assets/svg/new-cod.svg'


const _hoisted_1 = {
  key: 0,
  class: "relative inline-block"
}
const _hoisted_2 = { class: "font-semibold text-xs" }
const _hoisted_3 = {
  key: 0,
  class: "absolute mt-2 right-0 z-40 p-4 border border-green-lp-100 text-black-lp-100 bg-green-lp-500 rounded-2xl rounded-tr-none shadow-md",
  style: {"width":"426px"}
}
const _hoisted_4 = { class: "font-semibold text-base text-left" }
const _hoisted_5 = { class: "text-sm text-left" }
const _hoisted_6 = {
  class: "flex flex-col relative px-3 pt-4",
  style: {"max-height":"622px"}
}
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "text-sm font-medium text-gray-lp-600" }
const _hoisted_9 = { class: "flex flex-col items-start" }
const _hoisted_10 = {
  key: 0,
  src: _imports_0,
  class: "h-3"
}
const _hoisted_11 = {
  key: 1,
  src: _imports_1,
  class: "h-3"
}
const _hoisted_12 = { class: "flex flex-col" }
const _hoisted_13 = { class: "flex items-center gap-x-2" }
const _hoisted_14 = { class: "w-full h-full flex items-center justify-center" }
const _hoisted_15 = { class: "text-sm font-medium text-gray-lp-600" }
const _hoisted_16 = { class: "flex items-center gap-x-2" }
const _hoisted_17 = { class: "w-full h-full flex items-center justify-center" }
const _hoisted_18 = { class: "text-sm font-medium text-gray-lp-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_TableHistorySuccessBooking = _resolveComponent("TableHistorySuccessBooking")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showListHistorySuccessBooking)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openTable && _ctx.openTable(...args))),
            class: "rounded-full h-8 text-green-lp-200 flex items-center px-3 gap-2",
            style: {"background":"linear-gradient(90deg, #E3FCEF 0%, #CBFFFA 100%)"}
          }, [
            _createVNode(_component_Icons, {
              name: "print-summary",
              class: "w-4"
            }),
            _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("printReceipt.booking.title")), 1),
            (_ctx.badgeData.value)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "absolute -top-2 right-0 text-white text-xs font-semibold leading-none flex items-center justify-center bg-red-lp-100 rounded-full w-4 h-4",
                  style: _ctx.badgeData.style
                }, _toDisplayString(_ctx.badgeData.value), 5))
              : _createCommentVNode("", true)
          ]),
          (_ctx.visibleToastHistorySuccessBooking)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("p", _hoisted_4, _toDisplayString(_ctx.latestSttNumberSuccessBooking) + " " + _toDisplayString(_ctx.$t("printReceipt.booking.successBooked")), 1),
                _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("printReceipt.booking.checkHistory")), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_OverlayPanel, {
      id: "table-history-success-booking",
      ref: "table-history-success-booking",
      appendTo: "body",
      class: "w-auto",
      style: {
      backgroundColor: '#ffffff',
      color: '#4D4D4D'
    }
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_TableHistorySuccessBooking, {
            column: _ctx.column,
            data: _ctx.listData.data,
            "onUpdate:data": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listData.data = $event)),
            loading: _ctx.listData.loading,
            onRequest: _ctx.getList,
            onClose: _ctx.hideTable,
            onReset: _ctx.onReset,
            "error-type": _ctx.listData.errorType
          }, {
            "header:product-type": _withCtx(({data}) => [
              _createVNode("div", _hoisted_7, [
                _createVNode("span", null, _toDisplayString(data.name), 1),
                _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("printReceipt.booking.table.chargableWeight")), 1)
              ])
            ]),
            "body:stt-no": _withCtx(({data}) => [
              _createVNode("div", _hoisted_9, [
                _createVNode("span", null, _toDisplayString(data.sttNo), 1),
                (data.isDfod)
                  ? (_openBlock(), _createBlock("img", _hoisted_10))
                  : (data.isCod)
                    ? (_openBlock(), _createBlock("img", _hoisted_11))
                    : _createCommentVNode("", true)
              ])
            ]),
            "body:action": _withCtx(({data}) => [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", {
                    class: ["w-4 h-4 rounded-full", 
                  data.printReceiptFlag ? 'bg-green-lp-400' : 'bg-gray-lp-1300'
                ]
                  }, [
                    _createVNode("div", _hoisted_14, [
                      _createVNode(_component_Icons, {
                        name: "check",
                        class: "w-2.5 text-white"
                      })
                    ])
                  ], 2),
                  _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("printReceipt.booking.printReceipt")), 1)
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", {
                    class: ["w-4 h-4 rounded-full", 
                  data.createInvoiceFlag ? 'bg-green-lp-400' : 'bg-gray-lp-1300'
                ]
                  }, [
                    _createVNode("div", _hoisted_17, [
                      _createVNode(_component_Icons, {
                        name: "check",
                        class: "w-2.5 text-white"
                      })
                    ])
                  ], 2),
                  _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("printReceipt.booking.createInvoice")), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["column", "data", "loading", "onRequest", "onClose", "onReset", "error-type"])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}